<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><a class="page" id="pii"></a>Jewish Studies in the 21<sup>st</sup> Century</p>
<p class="seraft">Frederick E. Greenspahn is Gimelstob Eminent Scholar of Judaic Studies at Florida Atlantic University. Greenspahn is General Editor of the Jewish Studies in the 21st Century Series, and is the volume editor of the following books in the series:</p>
<p class="seraft"><i>The Hebrew Bible: New Insights and Scholarship</i></p>
<p class="ser"><i>Women and Judaism: New Insights and Scholarship</i></p>
<p class="ser"><i>Jewish Mysticism and Kabbalah: New Insights and Scholarship</i></p>
<p class="ser"><i>Contemporary Israel: New Insights and Scholarship</i></p>
<p class="ser"><i>Early Judaism: New Insights and Scholarship</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// greenspahnEarly-0003.vue?10855aae